import { useIsConnected } from "agora-rtc-react";

export const useAgoraIsConnected = () => {
  const isConnected = useIsConnected();
  return isConnected;
};
